import axios from "axios";
import config from "../../../config";

const API_URL = config?.TRAFFIC || "";
const SCENARIOMANAGER_URL = config?.SCENARIOMANAGER_URL;
const AUTH_ELASTIC = config?.AUTH_ELASTIC;

const AGGREGATION_BODY_PARAMS = {
  size: 0,
  query: {
    range: {
      TIMESTAMP: {
        gte: "now-5m/m",
      },
    },
  },
  aggs: {
    by_area: {
      terms: {
        field: "AREA",
        size: 100,
      },
      aggs: {
        avg_flow: {
          avg: {
            field: "FLOW",
          },
        },
        avg_speed: {
          avg: {
            field: "SPEED",
          },
        },
      },
    },
  },
};

// Function to transform area data
const transformAreaData = (data) => {
  if (!Array.isArray(data)) return []; // Prevent errors if data is null
  return data.map((area) => ({
    area_id: Number(area.area_id),
    name: area.name,
    name_el: area.name_el,
    crsName: area.geom?.crs?.properties?.name || "",
  }));
};

// Function to fetch and merge MFD data
export const speedFlowsMFDData = async () => {
  console.log("SCENARIOMANAGER_URL", SCENARIOMANAGER_URL);
  console.log("AUTH_ELASTIC", AUTH_ELASTIC);
  try {
    // 1. Fetch area metadata
    const areaResponse = await axios.get(`${API_URL}/id_areas`, {
      headers: { "Accept-Profile": "traffic_monitoring" },
    });

    // 2. Fetch real-time speedflow data
    const speedFlowResponse = await axios.get(
      `${SCENARIOMANAGER_URL}/speedflow/_search?size=10000`,
      {
        headers: { Authorization: AUTH_ELASTIC },
      }
    );

    // 3. Fetch typical values
    const aggResponse = await axios.post(
      "https://rcm-its.gr:10002/elastic/flow-speed-area/_search",
      AGGREGATION_BODY_PARAMS,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: AUTH_ELASTIC,
        },
      }
    );

    // 4. Transform area data
    const areas = transformAreaData(areaResponse.data || []);

    // 5. Transform real-time speedflow data
    const speedflowData = (speedFlowResponse.data?.hits?.hits || []).map(
      (item) => ({
        id: Number(item._source?.id) || 0,
        flow: parseFloat(item._source?.flow) || 0,
        speed: parseFloat(item._source?.speed) || 0,
        area_id: Number(item._source?.area) || 0, // Ensure numeric value
      })
    );

    // 6. Group speedflow data by area
    const groupedSpeedflow = speedflowData.reduce((acc, sf) => {
      const key = String(sf.area_id); // Ensure consistent key type
      acc[key] = acc[key] || [];
      acc[key].push(sf);
      return acc;
    }, {});

    // 7. Transform typical values from aggregation
    const typicalData = (
      aggResponse.data?.aggregations?.by_area?.buckets || []
    ).map((bucket) => ({
      area_id: Number(bucket.key),
      flow: bucket.avg_flow?.value ?? null,
      speed: bucket.avg_speed?.value ?? null,
    }));

    // Merge speedflow data with areas
    // const mergedAreas = areas.map((area) => ({
    //   ...area,
    //   realTime: groupedSpeedflow[String(area.area_id)] || [],
    // }));

    // 8. Merge everything into final result
    const mergedAreas = areas.map((area) => {
      const typical = typicalData.find((d) => d.area_id === area.area_id) || {};
      return {
        ...area,
        realTime: groupedSpeedflow[String(area.area_id)] || [],
        typical: {
          flow: typical.flow,
          speed: typical.speed,
        },
      };
    });

    // 9. Calculate global max speed and flow from all areas
    let maxSpeed = 0;
    let maxFlow = 0;

    console.log("mergedAreas", mergedAreas);
    
    
    mergedAreas.forEach((area) => {
      const speeds = [...area.realTime.map((r) => r.speed), area.typical?.speed || 0];
      const flows = [...area.realTime.map((r) => r.flow), area.typical?.flow || 0];
    
      const areaMaxSpeed = Math.max(...speeds);
      const areaMaxFlow = Math.max(...flows);
    
      if (areaMaxSpeed > maxSpeed) maxSpeed = areaMaxSpeed;
      if (areaMaxFlow > maxFlow) maxFlow = areaMaxFlow;
    });

    console.log("maxSpeed", maxSpeed);


  
    return {
      areas: mergedAreas,
      maxSpeed: Math.ceil(maxSpeed * 1.1), // 10% buffer
      maxFlow: Math.ceil(maxFlow * 1.1),
    };
  } catch (error) {
    console.error("Error fetching MFD data:", error.message);
    return null; // Ensure function always returns a predictable value
  }
};
